<template>
  <!-- 我的收藏 -->
  <div class="purse-body">
    <!-- 标题 -->
    <p class="title-Individual-center">
      个人中心 <i class="el-icon-arrow-right"></i>
      <span class="span-Individual-center">我的消息</span>
    </p>
    <!-- 内容主体 -->
    <div class="Content-subject">
      <!-- 筛选区 -->
      <div class="screen">
        <p>时间：</p>
        <el-date-picker
          v-model="value1"
          type="daterange"
          range-separator="-"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          value-format="yyyy-MM-dd"
          unlink-panels
          clearable
          @clear="value1 = null"
        >
        </el-date-picker>
        <p class="ser-btn" @click="handelSearch">搜 索</p>
        <p class="heavy-btn" @click="handelReset">重 置</p>
      </div>
      <!-- 切换 -->
      <div class="Toggle">
        <p
          v-for="(item, index) in selectArr"
          :key="index"
          :class="select == item.id ? 'select-p' : ''"
          @click="handelSelect(item)"
        >
          {{ item.name }}
        </p>
      </div>
      <!-- 批量删除 批量恢复 -->
      <div class="batch-btn">
        <div class="Tips" v-if="select == '5'">
          回收站信息保留30天，30天后自动清除
        </div>
        <p class="firm-clickable" v-if="select == '5'" @click="handelBatchRecovery">
          批量恢复{{
            multipleSelection.length != 0 ? multipleSelection.length : ""
          }}
        </p>
        <p class="delete-p" @click="handelDele">
          批量删除{{
            multipleSelection.length != 0 ? multipleSelection.length : ""
          }}
        </p>
      </div>
      <!-- 内容 -->
      <div class="collected">
        <tableMess
          :tableData="tableData"
          :select="select"
          :RefreshModule="RefreshModule"
          @Refresh="Refresh"
          @handleSelectionChange="handleSelectionChange"
        ></tableMess>
      </div>
      <!-- 底部分页 -->
      <div class="paging-box">
        <div class="paging">
          <paging
            :pagingObj="pagingObj"
            @handleCurrentChange="handleCurrentChange"
          ></paging>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// 引入接口
import {
  sysMsgList, // 消息列表
  trashMsg, //消息丢弃到回收站
  restoreMsg, //消息从回收站恢复
  delMsg, //删除消息
} from "../../../../../assets/api/CenterNotiFication";
// 引入分页组件
import paging from "../../../../../components/paging.vue";
// 引入表格组件
import tableMess from "./components/tableMess.vue";
export default {
  data() {
    return {
      pagingObj: {
        currentPage: 1, //当前页
        pageSize: 10, // 一页显示多少个
        totalDevice: 0, //总数
      }, // 分页数据
      value1: null, // 时间搜索
      select: "1", // 筛选
      selectArr: [
        { name: "全部消息", id: 1, argumentName: "delFlag", argument: 0 },
        { name: "系统消息", id: 2, argumentName: "msgType", argument: 0 },
        { name: "已读", id: 3, argumentName: "msgStatus", argument: 1 },
        { name: "未读", id: 4, argumentName: "msgStatus", argument: 0 },
        { name: "回收站", id: 5, argumentName: "delFlag", argument: 2 },
      ], //筛选数组
      tableData: [], //表格数据
      dialogDele: false, // 删除弹窗
      num: "", // 传参给组件区分样式 传给组件  56删除 7恢复
      multipleSelection: [], // 列表多选数据
      RefreshModule: 0, // 批量操作后改变该数传给组件，组件监听到此数据改变清空选中数据
    };
  },
  watch: {

  },
  components: {
    paging,
    tableMess,
  },
  created() {
    // 数据接口
    this.sysMsgList("", "", "");
   
  },
  methods: {
    // 表格多选数据
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    // 刷新列表数据
    RefreshSysMsgList() {
      if (this.select == 1) {
        this.sysMsgList("", "", "");
      } else if (this.select == 2) {
        this.sysMsgList(0, "", "");
      } else if (this.select == 3) {
        this.sysMsgList("", 1, "");
      } else if (this.select == 4) {
        this.sysMsgList("", 0, "");
      } else if (this.select == 5) {
        this.sysMsgList("", "", 2);
      }
    },
    // 从新加载数据
    Refresh() {
      setTimeout(() => {
        this.RefreshSysMsgList();
      }, 100);
    },
    // 重置
    handelReset() {
      this.pagingObj.currentPage = 1
      this.value1 = null;
      this.RefreshSysMsgList();
    },
    // 搜索
    handelSearch() {
       this.pagingObj.currentPage = 1
      this.RefreshSysMsgList();
    },
   
    // 消息列表
    async sysMsgList(msgType, msgStatus, delFlag) {
      var data = {};
      // 处理时间
      var time;
      var timeEnd;
      var arr;
      var arr1;
      var range = this.value1;
      if (Array.isArray(range) && range.length === 2 && range[0] && range[1]) {
        time = range[0] + " " + "00:00:00";
        timeEnd = range[1] + " " + "23:59:59";
        arr = new Date(time).getTime(time);
        arr1 = new Date(timeEnd).getTime(timeEnd);
      }

      data.data = {
        userId: this.$store.getters.getUser.id, //id
        msgType: msgType, // 消息类型 0系统消息
        msgStatus: msgStatus, // 消息状态 0未读 1已读
        delFlag: delFlag, //消息 0全部消息  2回收站
        startTime: arr, // 搜索/筛选传的 开始时间
        endTime: arr1, // 搜索/筛选传的 结束时间
      };
      const res = await sysMsgList(
        data,
        this.pagingObj.currentPage,
        this.pagingObj.pageSize
      );
      if (res.code == 0) {
        this.pagingObj.totalDevice = res.data.totalCount;
        this.tableData = res.data.rows;
      }
    },
    // 消息类型的切换
    handelSelect(item) {
      this.pagingObj = {
        currentPage: 1, //当前页
        pageSize: 10, // 一页显示多少个
        totalDevice: 0, //用户总数
      }; // 分页数据
      if (item.id == 1) {
        this.sysMsgList("", "", "");
      } else if (item.id == 2) {
        this.sysMsgList(0, "", "");
      } else if (item.id == 3) {
        this.sysMsgList("", 1, "");
      } else if (item.id == 4) {
        this.sysMsgList("", 0, "");
      } else if (item.id == 5) {
        this.sysMsgList("", "", 2);
      }
      this.select = item.id;
    },
    //批量恢复
    handelBatchRecovery() {
      // 大于0表格已有选中 反之表格并无数据选中
      if (this.multipleSelection.length > 0) {
        this.$confirmWithScroll(`确定要恢复选中的 ${this.multipleSelection.length} 条消息吗？`, "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }).then(() => {
          var arr = [];
          var k = 0;
          // 循环取出msgId放入数组
          for (var i in this.multipleSelection) {
            arr[k++] = this.multipleSelection[i].msgId;
          }
          var data = {
            data: {
              msgIds: arr,
              userId: this.$store.getters.getUser.id,
            },
          };
          restoreMsg(data).then((res) => {
            if (res.code == 0) {
              this.$tool.PromptBox("success", "操作成功");
              this.Refresh();
            }
          });
        }).catch(() => {
          // 用户取消恢复
        });
      } else {
        this.$tool.PromptBox("warning", "请选择要恢复的数据");
      }
    },
    // 批量删除
    handelDele() {
      if (this.multipleSelection.length > 0) {
        const confirmText = this.select == "5" ? `确定要彻底删除选中的 ${this.multipleSelection.length} 条消息吗？` : `确定要删除选中的 ${this.multipleSelection.length} 条消息吗？`;
        this.$confirmWithScroll(confirmText, "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }).then(() => {
          var arr = [];
          var k = 0;
          // 循环取出msgId放入数组
          for (var i in this.multipleSelection) {
            arr[k++] = this.multipleSelection[i].msgId;
          }
          var data = {
            data: {
              msgIds: arr,
              userId: this.$store.getters.getUser.id,
            },
          };
          // 判断操作的是回收站的数据还是其他列表的数据
          if (this.select == "5") {
            // 等于5是在回收站 删除时使用彻底删除接口
            delMsg(data).then((res) => {
              if (res.code == 0) {
                this.$tool.PromptBox("success", "操作成功");
                this.Refresh();
              }
            });
          } else {
            // 其余情况使用将数据放入回收站接口
            trashMsg(data).then((res) => {
              if (res.code == 0) {
                this.$tool.PromptBox("success", "操作成功");
                this.Refresh();
              }
            });
          }
        }).catch(() => {
          // 用户取消删除
        });
      } else {
        this.$tool.PromptBox("warning", "请选择要删除的数据");
      }
    },

    // 分页
    handleCurrentChange(val) {
      this.pagingObj.currentPage = val;
      this.RefreshSysMsgList();
    },
  },
};
</script>

<style scoped lang="less">
// el-range-editor el-input__inner el-date-editor--daterange
/deep/.el-date-editor {
  box-sizing: border-box !important;
  border: 1px solid #409eff ;
  height: 35px;
  width: 240px;
  line-height: 35px !important;
  // margin-top: -2px;
  padding: 0 8px !important;
}
/deep/.el-icon-date {
  font-size: 18px !important;
  margin-left: 0 !important;
}
/deep/.el-range__close-icon {
  line-height: 35px;
  width: 25px;
}

.purse-body {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
}
// 内容主体
.Content-subject {
  width: 100%;
  min-height: 540px;
  box-sizing: border-box;
  background: #ffffff;
  box-shadow: 0px 0px 3px 0px rgba(125, 125, 125, 0.5);
  border-radius: 5px;
  margin-top: 13px;
  padding: 30px;
  // screen筛选
  .screen {
    min-width: 470px;
    height: 35px;
    line-height: 35px;
    font-family: PingFangSC-Medium;
    font-size: 12px;
    color: #333333;
    font-weight: 400;
    display: flex;
    .ser-btn {
      width: 75px;
      height: 35px;
      text-align: center;
      background: #409eff ;
      border-radius: 5px;
      font-family: PingFangSC-Medium;
      font-size: 14px;
      color: #ffffff;
      font-weight: 400;
      box-sizing: border-box;
      border: 1px solid #409eff ;
      margin-left: 30px;
      margin-right: 10px;
      cursor: pointer;
    }
    .heavy-btn {
      width: 75px;
      height: 35px;
      text-align: center;
      background: #ffffff;
      box-sizing: border-box;
      border: 1px solid #409eff ;
      border-radius: 5px;
      font-family: PingFangSC-Medium;
      font-size: 14px;
      color: #409eff ;
      font-weight: 400;
      cursor: pointer;
    }
  }
  // 切换
  .Toggle {
    width: 90%;
    height: 30px;
    margin-top: 30px;
    display: flex;
    font-family: PingFangSC-Medium;
    font-size: 16px;
    color: #333333;
    text-align: center;
    font-weight: 400;
    p {
      margin-right: 30px;
      cursor: pointer;
    }
    .select-p {
      color: #409eff ;
      box-sizing: border-box;
      border-bottom: 2px solid #409eff ;
    }
  }
  // 批量删除  批量恢复
  .batch-btn {
    width: 100%;
    height: 35px;
    line-height: 35px;
    margin: 0 auto;
    margin-top: 15px;
    display: flex;
    justify-content: flex-end;
    p {
      width: 100px;
      height: 35px;
      line-height: 35px;
      background: #409eff ;
      border-radius: 5px;
      font-family: PingFangSC-Medium;
      font-size: 14px;
      color: #ffffff;
      text-align: center;
      font-weight: 400;
      margin-left: 20px;
      cursor: pointer;
    }
    .delete-p {
      background: #fe574a;
    }
    .Tips {
      flex: 1;
      text-align: left;
      font-size: 14px;
      color: #fe574a;
      font-weight: 400;
    }
  }
  // 收藏的内容
  .collected {
    min-height: 410px;
    margin: 0 auto;
    margin-top: 15px;
  }
  // 分页
  .paging-box {
    width: 100%;
    height: 22px;
    margin-top: 30px;
    display: flex;
    justify-content: flex-end;
    .paging {
      width: 90%;
      height: 100%;
      display: flex;
      justify-content: flex-end;
    }
  }
}
</style>
